// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Contact from './pages/Contact';
import Presence from './components/Presence';
import CalviaceXT from "./pages/CalviaceXT";
import Thioxigen4 from "./pages/Thioxigen4";
import NorviaceNT from "./pages/NorviaceNT";
import Torviset from "./pages/Torviset";
import Nitrozex from "./pages/Nitrozex";
import EsciwonPlus from "./pages/EsciwonPlus";


function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/presence" element={<Presence />} />
        <Route path="/products/calviace-xt" element={<CalviaceXT />} />
        <Route path="/products/thioxigen-4" element={<Thioxigen4 />} />
<Route path="/products/norviace-nt" element={<NorviaceNT />} />
<Route path="/products/torviset" element={<Torviset />} />
<Route path="/products/nitrozex" element={<Nitrozex />} />
<Route path="/products/esciwon-plus" element={<EsciwonPlus />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
